module.exports = ".subjects-chip-list {\n  width: 100%; }\n\n#subjectInput {\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n          box-shadow: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/exam-boards/components/add-edit-exam-board/add-edit-exam-board.component.scss
// module id = ./src/app/main/content/pages/management/exam-boards/components/add-edit-exam-board/add-edit-exam-board.component.scss
// module chunks = main